import Vue from 'vue';
import types from '../../mutation-types';

export const mutations = {
  [types.SET_FRANCHISE_UI_FLAG]($state, data) {
    $state.uiFlags = { ...$state.uiFlags, ...data };
  },

  [types.CLEAR_FRANCHISES]($state) {
    Vue.set($state, 'records', {});
    Vue.set($state, 'sortOrder', []);
  },

  [types.SET_FRANCHISE_META]($state, data = {}) {
    const { count = 0, current_page: currentPage = 1 } = data;
    Vue.set($state.meta, 'count', count);
    Vue.set($state.meta, 'currentPage', currentPage);
  },

  [types.SET_FRANCHISES]($state, data = []) {
    const sortOrder = data.map(franchise => {
      Vue.set($state.records, franchise.id, {
        ...($state.records[franchise.id] || {}),
        ...franchise,
      });
      return franchise.id;
    });
    $state.sortOrder = sortOrder;
  },

  [types.SET_ALL_FRANCHISES]($state, data = []) {
    $state.allFranchises = data;
  },

  [types.SET_FRANCHISE_ITEM]($state, data) {
    Vue.set($state.records, data.id, {
      ...($state.records[data.id] || {}),
      ...data,
    });
    if (!$state.sortOrder.includes(data.id)) {
      $state.sortOrder.push(data.id);
    }
  },

  [types.SET_CURRENT_FRANCHISE]($state, data = {}) {
    Vue.set($state, 'currentFranchise', data);
  },

  [types.EDIT_FRANCHISE]($state, data) {
    if ($state.records[data.id]) {
      Vue.set($state.records, data.id, { ...$state.records[data.id], ...data });
    }
    if ($state.currentFranchise.id === data.id) {
      Vue.set($state, 'currentFranchise', {
        ...$state.currentFranchise,
        ...data,
      });
    }
  },

  [types.DELETE_FRANCHISE]($state, id) {
    const index = $state.sortOrder.findIndex(
      item => String(item) === String(id)
    );
    if (index !== -1) {
      Vue.delete($state.sortOrder, index);
    }
    Vue.delete($state.records, id);
    if (String($state.currentFranchise.id) === String(id)) {
      Vue.set($state, 'currentFranchise', {});
    }
    $state.selectedFranchiseIds = $state.selectedFranchiseIds.filter(
      fid => String(fid) !== String(id)
    );
  },

  [types.SET_SELECTED_FRANCHISE_IDS]($state, ids = []) {
    $state.selectedFranchiseIds = ids;
  },

  [types.CLEAR_SELECTED_FRANCHISE_IDS]($state) {
    $state.selectedFranchiseIds = [];
  },

  // Units
  [types.SET_FRANCHISE_UNITS_UI_FLAG]($state, data) {
    $state.uiFlagsUnits = { ...$state.uiFlagsUnits, ...data };
  },

  [types.SET_FRANCHISE_UNITS]($state, data = []) {
    $state.units = data;
  },

  [types.SET_FRANCHISE_ALL_UNITS]($state, data = []) {
    $state.allUnits = data;
  },

  [types.ADD_FRANCHISE_UNIT]($state, data) {
    if (data?.id) {
      const existing = $state.units.findIndex(u => u.id === data.id);
      if (existing >= 0) {
        Vue.set($state.units, existing, { ...$state.units[existing], ...data });
      } else {
        $state.units.push(data);
      }
    }
  },

  [types.UPDATE_FRANCHISE_UNIT]($state, data) {
    const idx = $state.units.findIndex(u => u.id === data.id);
    if (idx >= 0) {
      Vue.set($state.units, idx, { ...$state.units[idx], ...data });
    }
  },

  [types.DELETE_FRANCHISE_UNIT]($state, id) {
    const idx = $state.units.findIndex(u => String(u.id) === String(id));
    if (idx >= 0) {
      Vue.delete($state.units, idx);
    }
  },

  // Attendants
  [types.SET_FRANCHISE_ATTENDANTS_UI_FLAG]($state, data) {
    $state.uiFlagsAttendants = { ...$state.uiFlagsAttendants, ...data };
  },

  [types.SET_FRANCHISE_ATTENDANTS]($state, data = []) {
    $state.attendants = data;
  },

  // Upsert por user_id: a mesma entrada volta do create e do update, porque as duas operacoes
  // respondem "esta pessoa atende a estas unidades". Chavear por id de linha faria a edicao
  // empilhar uma segunda entrada da mesma pessoa na lista.
  [types.ADD_FRANCHISE_ATTENDANT]($state, data) {
    if (!data?.user_id) return;

    const idx = $state.attendants.findIndex(
      a => String(a.user_id) === String(data.user_id)
    );
    if (idx >= 0) {
      Vue.set($state.attendants, idx, data);
    } else {
      $state.attendants.push(data);
    }
  },

  [types.DELETE_FRANCHISE_ATTENDANT]($state, userId) {
    const idx = $state.attendants.findIndex(
      a => String(a.user_id) === String(userId)
    );
    if (idx >= 0) {
      Vue.delete($state.attendants, idx);
    }
  },
};
